export const isLatinAndStandardChars = (input: string): boolean => {
  if (!input) return true;
  const regex = /^[\x20-\x7E]*$/;

  return regex.test(input);
};
